export default IconSuperscript => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-superscript" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 7l8 10m-8 0l8 -10" />
  <path d="M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2" />
</svg>`;